import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  gap: 1rem;
`;
